<template>
  <div class="d-sm-flex justify-content-sm-between align-items-center">
    <h6 class="mb-0 text-sm font-weight-bold">{{ result.name }}</h6>
    <div class="d-flex align-items-center">
      <div class="tour-price font-weight-bolder mr-3 text-danger">
        <span v-if="$route.name === 'Private/Tour/Search'">
          <small>de la</small>
          {{ minPrice.toFixed(2) }} {{ result.currency }}
        </span>
        <slot></slot>
      </div>
      <b-button
        variant="outline-info"
        size="sm"
        @click="$emit('toggle')"
        >
        <b-iconstack>
          <b-icon icon="square" scale="0.8" stacked />
          <b-icon icon="check" v-if="selected" scale="0.7" stacked />
        </b-iconstack>
        PDF
      </b-button>
      <b-button
        variant="info"
        @click="$emit('info')"
        size="sm"
        class="mx-2">
        <b-icon icon="info-circle-fill" />
      </b-button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    result: {
      type: Object,
      required: true
    },
    selected: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    minPrice () {
      let minPrice = 0
      for (const key in this.result.dates) {
        const price = this.result.dates[key].price.gross + this.result.dates[key].price.tax
        if (minPrice === 0) minPrice = price
        if (price < minPrice) minPrice = price
      }
      return minPrice
    }
  }
}
</script>
